import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row items-center q-gutter-x-md" }
const _hoisted_2 = { class: "col-auto" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "page__header-title" }
const _hoisted_5 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_s_btn_back = _resolveComponent("s-btn-back")!
  const _component_q_skeleton = _resolveComponent("q-skeleton")!
  const _component_page_header_base = _resolveComponent("page-header-base")!

  return (_openBlock(), _createBlock(_component_page_header_base, null, {
    start: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.back)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (!_ctx.isLoading && _ctx.back)
                  ? (_openBlock(), _createBlock(_component_s_btn_back, {
                      key: 0,
                      label: _ctx.backLabel,
                      to: _ctx.back,
                      class: _normalizeClass({ 's-mb-lg s-mr-sm': _ctx.backMargin })
                    }, null, 8, ["label", "to", "class"]))
                  : (_openBlock(), _createBlock(_component_q_skeleton, {
                      key: 1,
                      class: "s-skeleton",
                      width: "200px",
                      height: "32px",
                      type: "QBtn",
                      animation: "fade"
                    }))
              ]))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "after-back")
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "title", { title: _ctx.title }, () => [
          (!_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.title), 1))
            : (_openBlock(), _createBlock(_component_q_skeleton, {
                key: 1,
                class: "s-skeleton q-mt-md",
                width: "600px",
                height: "32px",
                type: "QBtn",
                animation: "fade"
              }))
        ])
      ]),
      _renderSlot(_ctx.$slots, "after-title")
    ]),
    end: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    bottom: _withCtx(() => [
      _renderSlot(_ctx.$slots, "bottom")
    ]),
    _: 3
  }))
}